export default __webpack_public_path__ + "static/media/itch-icon-21-pink.d764a8d0.svg";